import * as yup from 'yup';

const addToFlowSchema = yup.object().shape({
  flows: yup.array().of(yup.number().integer().required()).required().label('Flows'),
  indeterminate: yup.object().shape({}),
});

export default addToFlowSchema;
